module.exports = __webpack_public_path__ + "img/lock.f4ff576f.svg";